import { useEffect, useRef } from 'react';
import { checkSessionTimeLeftWithToken } from 'components/sessionTimeOut/utils/checkSessionTimeLeft';
import { PUBLICA_URL } from 'constants';

export const useTimeLeftCheckFromExpirationRequest = ({ session, accessToken, checkSession }) => {
    const checkIntervalRef = useRef(null);

    const startTimeLeftCheck = () => {
        checkIntervalRef.current = setInterval(
            () =>
                checkSessionTimeLeftWithToken({
                    accessToken,
                    checkSession,
                }),
            21000
        );
    };

    const stopTimeLeftCheck = () => {
        clearInterval(checkIntervalRef.current);
    };

    useEffect(() => {
        startTimeLeftCheck();

        return () => {
            stopTimeLeftCheck();
        };
    }, [accessToken]);

    useEffect(() => {
        const sessionStatus = session.get('sessionStatus');

        if (sessionStatus.get('errorInResponse')) {
            stopTimeLeftCheck();
            window.location.href = PUBLICA_URL;
        }
    }, [session]);

    return { startTimeLeftCheck, stopTimeLeftCheck };
};
